export const TOGGLE_USER_ROLES_START = 'TOGGLE_USER_ROLES_START';
export const TOGGLE_USER_ROLES_SUCCESS = 'TOGGLE_USER_ROLES_SUCCESS';
export const TOGGLE_USER_ROLES_FAILURE = 'TOGGLE_USER_ROLES_FAILURE';
